module.exports = __webpack_public_path__ + "fonts/SofiaProBlack-Italic.fc76bf50.eot";